import { useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect, useRef, useState } from 'react'
import './WorkDetails.css'
import { useWorkStateFields } from '../../store/hooks';
import Carousel from "react-gallery-carousel";
import "react-gallery-carousel/dist/index.css";
import redHideIcon from '../../images/Hide-Button-Red.png'
import shareIcon from '../../images/share.png'
import heartIcon from '../../images/heart.png'
import redHeartIcon from '../../images/redHeart.png'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlus, faArrowLeft, faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { guestUpload, blacklistReview, userFolders, likePhotos, allPhotos, viewPhotos, deleteUploads, hide, approvePhoto, firefox } from "../../context/workConstants";
import downloadIcon from '../../images/download.png'
import whiteHideIcon from '../../images/Hide-Button-White.png'
import deleteIcon from '../../images/delete.png'
import Popup from "../../components/Popup/Popup.js";
import { get_can_add_to, get_can_delete, get_can_flag_pics, get_can_make_private, get_global_can_add_to, get_selected_workId,
         get_global_is_album_required, get_is_album_required, get_is_downloadable, get_user_liked_photos, get_can_edit_draft_album, has_hd_quality } from "./work_utils.js";
import { globalLoader, get_platform_bg_color, getMobileOperatingSystem, get_platform_action_color, isAdmin,
         getAuthToken, getAllChildClassNames, exportImage, getBrowserType} from "../../script/util";
import axios from "axios";

const GalleryCarousel = ({ closeGalleryHandler, getLikesData, updateAlbum, updateFolders, handleFilterCheckboxChange, filteredPhotoCount, showTilesUpTo }) => {
    const navigate = useNavigate()
    const routerLocation = useLocation()
    const [showPrintAlbumTip, setShowPrintAlbumTip] = useState(false);
    const queryParams = new URLSearchParams(window.location.search);
    const tab = queryParams.get("tab")
    const showTrash = queryParams.get("trash")
    const collection_id = queryParams.get("work_id")
    const shared_key = queryParams.get("key")
    const browser = getBrowserType();
    const {
        data, collection, collectionData, galleryImages, hdUrl, currentDimensions, showGallery, selection, setAddToSelection, setPrintSelection, firstCheck,
        photoIndex, hideSelectedObj, nextCollectionName, prevCollectionName, faceSearchData, faceSearchOn, faceHide, albumData, indexDisplay,
        albumLocked, likeViewPopup, setLikeViewPopup, setNewFolderPopup, setFlagPhotoPopup, isSingleAddToOpen, setIsSingleAddToOpen, selectedOption,
        likeData, currentPhotoFlagged, libraryData, thumbRef, carouselRef, popupRef, currentPhotoLiked, setCurrentPhotoLiked, setLikeData, height, deleteConfirm,
        loadingHD, setLoadingHD, setHdUrl, setShowToast, setToastMessage, initialCarousel, setInitialCarousel, singleAlbumData,
        setGalleryNextCollectionPopup, setGalleryCollectionName, setGalleryRightArrow, setIndexDisplay, setPhotoIndex,
        collectionFormattedData, setSelectionType, setMultipleSelect, setUpdateSinglePhoto, setDeletePopup, faceFormattedData, images, yourUploads,
        setSelectionAll, setSelectedImages, setFaceSelect, reloadDelete, viewTimeoutRef, setFullScreen,
    } = useWorkStateFields(['data', 'collection', 'collectionData', 'galleryImages', 'hdUrl', 'currentDimensions', 'showGallery', 'selection', 'photoIndex', 'hideSelectedObj', 'nextCollectionName', 'prevCollectionName', 'faceSearchData', 'faceSearchOn', 'faceHide', 'albumData', 'indexDisplay', 'albumLocked', 'likeViewPopup', 'isSingleAddToOpen', 'selectedOption', 'likeData', 'currentPhotoFlagged', 'libraryData', 'currentPhotoLiked', 'height', 'deleteConfirm', 'loadingHD', 'initialCarousel', 'singleAlbumData', 'collectionFormattedData', 'faceFormattedData', 'images', 'reloadDelete', 'yourUploads']);
    // Deliverable admins can view but not edit the draft album. UX gate only.
    const canEditDraftAlbum = get_can_edit_draft_album(collection, data);

    const play = document.getElementsByClassName("_ZTBlf");
    if (play[0]) play[0].style.marginLeft = "50px";

    // The count for the active filter (Hidden, Public, My uploads, Collections), not the whole collection.
    const totalPhotoCount = Number(filteredPhotoCount) || galleryImages?.length || 0;
    const allPhotosFullyLoaded = (galleryImages?.length || 0) >= totalPhotoCount;

    const isFullscreenTogglingRef = useRef(false);

    // Reporting is for other guests' photos, so the uploader doesn't get it on their own.
    const isOwnUpload = (yourUploads || []).some((p) => p?.photo_id === galleryImages?.[photoIndex - 1]?.photo_id);

    useEffect(() => {
        if (!showGallery) return;

        const fullSize = document.getElementsByClassName("_lfOsC _dZ8C-");
        const btn = fullSize?.[1];
        if (!btn) return;

        const onToggleFullscreen = async () => {
            if (isFullscreenTogglingRef.current) return;
            isFullscreenTogglingRef.current = true;

            try {
                const elem = thumbRef.current;
                if (!document.fullscreenElement) {
                    setFullScreen(true);
                    if (elem?.requestFullscreen) {
                        await elem.requestFullscreen();
                    } else if (elem?.mozRequestFullScreen) {
                        elem.mozRequestFullScreen();
                    } else if (elem?.webkitRequestFullscreen) {
                        elem.webkitRequestFullscreen();
                    }
                } else {
                    setFullScreen(false);
                    if (document.exitFullscreen) {
                        await document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    }
                    carouselRef.current?.toggleIsPlaying?.();
                }
            } catch (e) {
                setFullScreen(Boolean(document.fullscreenElement));
            } finally {
                isFullscreenTogglingRef.current = false;
            }
        };

        btn.addEventListener("click", onToggleFullscreen);
        return () => {
            btn.removeEventListener("click", onToggleFullscreen);
        };
    }, [showGallery, setFullScreen, thumbRef, carouselRef]);

    const handlePhotoHide = (photo_id) => {
        if(!isAdmin()){
            setSelectionType(hide)
            const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData;
            const selectedWorkId = get_selected_workId(selectedData, photo_id)
            const photoObj = faceSearchOn 
                ? faceFormattedData[selectedWorkId].find((obj) => obj.photo_id === photo_id) 
                : collectionFormattedData[selectedWorkId].find((obj) => obj.photo_id === photo_id);
            if (firstCheck.current) {
                document.getElementById('hidePopupDiv').style.display = 'flex';
                
                const isHidden = faceSearchOn
                    ? faceHide[selectedWorkId].some(e => e.photo_id === photo_id)
                    : hideSelectedObj[collection_id].some(e => e.photo_id === photo_id);
        
                document.getElementById('hideButtonGallery').innerText = isHidden ? 'Unhide' : 'Hide';
                document.getElementById('popupTitle').innerText = isHidden ? 'Unhide' : 'Hide';
                document.getElementById('popupDesc').innerText = isHidden
                    ? 'Unhidden photos are visible to everyone with whom they are shared'
                    : 'Hidden photos are invisible to everyone with whom they are shared';
        
            } else {
                setMultipleSelect((prevMultipleSelect) => {
                    const index = prevMultipleSelect.findIndex((obj) => obj.work_id === selectedWorkId);
        
                    if (index === -1) {
                        prevMultipleSelect = [
                            ...prevMultipleSelect,
                            { work_id: selectedWorkId, select_list: [], unselect_list: [] },
                        ];
                    }
        
                    return prevMultipleSelect.map((item) => {
                        if (item.work_id === selectedWorkId) {
                            const isInSelect = faceSearchOn
                                ? JSON.stringify(faceHide[selectedWorkId]).includes(photo_id)
                                : JSON.stringify(hideSelectedObj[selectedWorkId]).includes(photo_id);
                            if (isInSelect) {
                                if (!faceSearchOn) {
                                    setSelectedImages((prev) => ({
                                        ...prev,
                                        [selectedWorkId]: prev[selectedWorkId]?.filter((img) => img.photo_id !== photo_id) || [],
                                    }));
                                } else {
                                    setFaceSelect((prev) => ({
                                        ...prev,
                                        [selectedWorkId]: prev[selectedWorkId]?.filter((img) => img.photo_id !== photo_id) || [],
                                    }));
                                }
                                setSelectionAll((prev)=>({
                                    ...prev,
                                    [collection_id]: false
                                }))

                                return {
                                    ...item,
                                    select_list: item.select_list.filter((e) => e !== photo_id),
                                    unselect_list: [...item.unselect_list, photo_id],
                                };
                            } else {
                                if (!faceSearchOn) {
                                    setSelectedImages((prev) => ({
                                        ...prev,
                                        [selectedWorkId]: [...prev[selectedWorkId] || [], photoObj],
                                    }));
                                } else {
                                    setFaceSelect((prev) => ({
                                        ...prev,
                                        [selectedWorkId]: [...prev[selectedWorkId] || [], photoObj],
                                    }));
                                }
                                return {
                                    ...item,
                                    unselect_list: item.unselect_list.filter((e) => e !== photo_id),
                                    select_list: [...item.select_list, photo_id],
                                };
                            }
                        }
                        return item;
                    });
                });
                setUpdateSinglePhoto(true);
            }
        }
    };

    const handlePlayClick = (event) => {
        const arrowClassNames = [];
        let current = event.target.parentElement;

        while (current) {
            if (current.className) {
            if (typeof current.className === 'string') {
                arrowClassNames.push(...current.className.trim().split(/\s+/));
            } else if (current.classList) {
                arrowClassNames.push(...Array.from(current.classList));
            }
            }
            current = current.parentElement;
        }
        const descendantClassNames = getAllChildClassNames('topControls');
        const likedStoriesDescendentClassNames = getAllChildClassNames('likedStories');
        const excludedClasses = ['topControls', 'likedStories', 'popup-content', '_3lwW_', 'likeViewPopup', ...descendantClassNames, ...likedStoriesDescendentClassNames];
        const isInsideExcluded = excludedClasses?.some(cls => event.target.closest(`.${cls}`));
        if(!initialCarousel && isInsideExcluded){
            setInitialCarousel(true);
        }
        if (!isInsideExcluded || arrowClassNames.includes('carouselButtons')) {
            setInitialCarousel(false);
        }
        const targetEle = document.getElementsByClassName('_ZTBlf')[0]
        const actionEle = document.getElementsByClassName('topControls')[0]
        targetEle.addEventListener('click', function(){
            if(targetEle?.getAttribute('aria-label').split(' ')[0]=='Start'){
                actionEle.style.display = 'none'
            }
            if(targetEle?.getAttribute('aria-label').split(' ')[0]=='Pause'){
                actionEle.style.display = 'flex'
            }
        })
    }

    const toggleSingleAddToPopup = () => {
        setIsSingleAddToOpen(!isSingleAddToOpen);
        setAddToSelection(true)
    };

    const checkAlbumKey = (photoId, albumKey) => {
        albumKey = Number(albumKey)
        if(photoId in singleAlbumData){
            for(let i=0; i<singleAlbumData[photoId].length; i++){
                if(singleAlbumData[photoId][i] == albumKey){
                    return true;
                }
            }
        }
        return false;
    };


    const checkFolderKey = (photoId, folderKey) => {
        folderKey = Number(folderKey)
        const singleFolder = libraryData?.photo_id_map
        if(photoId in singleFolder){
            for(let i=0; i<singleFolder[photoId].length; i++){
                if(singleFolder[photoId][i] == folderKey){
                    return true;
                }
            }
        }
        return false;
    }

    const handleDeletePhoto = (photo_id) => {
        const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData;
        const selectedWorkId = get_selected_workId(selectedData, photo_id)
        setSelectionType(deleteUploads)
        setMultipleSelect((prevMultipleSelect) => {
            const index = prevMultipleSelect.findIndex((obj) => obj.work_id === selectedWorkId);
            if (index === -1) {
                prevMultipleSelect = [
                    ...prevMultipleSelect,
                    { work_id: selectedWorkId, select_list: [], unselect_list: [] },
                ];
            }

            return prevMultipleSelect.map((item) => {
                if (item.work_id === selectedWorkId) {
                    return {
                        ...item,
                        unselect_list: item.unselect_list.filter((e) => e !== photo_id),
                        select_list: [...item.select_list, photo_id],
                    };
                }
                return item;
            });
        });
        if(!deleteConfirm){
            setDeletePopup(true)
        }
    }


    const handleLikeViewPhoto = (photo_id, type) => {
        const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData;
        const selectedWorkId = get_selected_workId(selectedData, photo_id)

        if (type === likePhotos) {
            const authDict = JSON.parse(localStorage.getItem("auth_dict") || "{}");
            const currentUserFirstName = authDict?.eventGraphiaName;
            const currentUserInitials = authDict?.eventGraphiaInitials;

            setLikeData(prev => {
                const prevData = prev || {};
                const work = prevData[selectedWorkId] || {};
                const photo = work[photo_id] || {};

                const wasLiked = !!photo.user_liked;
                const nextLiked = !wasLiked;
                const currentLikes = photo.total_likes || 0;
                const nextTotalLikes = nextLiked
                    ? currentLikes + 1
                    : Math.max(0, currentLikes - 1);

                let nextUserList = photo.user_list || [];

                if (currentUserInitials) {
                    const existingIndex = nextUserList.findIndex(
                        (u) => u?.name_initials === currentUserInitials
                    );

                    if (nextLiked) {
                        // Like: add or update current user
                        if (existingIndex !== -1) {
                            nextUserList = nextUserList.map((u, idx) =>
                                idx === existingIndex ? { ...u, is_liked: true } : u
                            );
                        } else if (currentUserFirstName) {
                            nextUserList = [
                                ...nextUserList,
                                {
                                    first_name: currentUserFirstName,
                                    name_initials: currentUserInitials,
                                    is_liked: true,
                                },
                            ];
                        }
                    } else {
                        // Unlike: remove current user from list
                        if (existingIndex !== -1) {
                            nextUserList = nextUserList.filter((_, idx) => idx !== existingIndex);
                        }
                    }
                }

                // If user unliked and there are no users and no likes left, remove photoId
                if (!nextLiked && nextUserList.length === 0 && nextTotalLikes === 0) {
                    const nextWork = { ...work };
                    delete nextWork[photo_id];

                    if (Object.keys(nextWork).length === 0) {
                        const nextData = { ...prevData };
                        delete nextData[selectedWorkId];
                        return nextData;
                    }

                    return {
                        ...prevData,
                        [selectedWorkId]: nextWork,
                    };
                }

                return {
                    ...prevData,
                    [selectedWorkId]: {
                        ...work,
                        [photo_id]: {
                            ...photo,
                            user_liked: nextLiked,
                            total_likes: nextTotalLikes,
                            ...(nextUserList.length ? { user_list: nextUserList } : {}),
                        },
                    },
                };
            });
        }

        type===likePhotos && setCurrentPhotoLiked(prev=>!prev)
        // likeData is never populated on the face-search tab, so guard the first access too
        const inSelect = type===viewPhotos ? false : (likeData?.[selectedWorkId]?.[photo_id]?.user_liked ? true : false)
        setSelectionType(type)
        setMultipleSelect((prevMultipleSelect) => {
            const index = prevMultipleSelect.findIndex((obj) => obj.work_id === selectedWorkId);
            if (index === -1) {
                prevMultipleSelect = [
                    ...prevMultipleSelect,
                    { work_id: selectedWorkId, select_list: [], unselect_list: [] },
                ];
            }

            return prevMultipleSelect.map((item) => {
                if (item.work_id === selectedWorkId) {
                    if(!inSelect){
                        return {
                            ...item,
                            unselect_list: item.unselect_list.filter((e) => e !== photo_id),
                            select_list: [...item.select_list, photo_id],
                        };
                    }else{
                        return {
                            ...item,
                            select_list: item.select_list.filter((e) => e !== photo_id),
                            unselect_list: [...item.unselect_list, photo_id],
                        };
                    }
                }
                return item;
            });
        });
        setUpdateSinglePhoto(true);
    }

    const handleIndexChange = (e) => {
        setLikeViewPopup(false)
        if(showGallery && photoIndex){
            recordViews(galleryImages[e.curIndex]?.photo_id)
        }
        let num = parseInt(e.curIndexForDisplay, 10);
        if(num>=e.curIndex && num == galleryImages.length){
            if((num == photoIndex) && (selectedOption == allPhotos) && nextCollectionName && !faceSearchOn && allPhotosFullyLoaded){
                setGalleryNextCollectionPopup(true)
                setGalleryCollectionName(nextCollectionName)
                setGalleryRightArrow(true)
            }
        }else{
            if((photoIndex==1 && num==1) && (selectedOption == allPhotos) && prevCollectionName && !faceSearchOn && allPhotosFullyLoaded){
                setGalleryNextCollectionPopup(true)
                setGalleryCollectionName(prevCollectionName)
                setGalleryRightArrow(false)
            }
        }
        setIndexDisplay(num);
        setPhotoIndex(num);
        showTilesUpTo?.(num);
        navigate(
            { pathname: routerLocation.pathname, search: routerLocation.search, hash: `#gallery?index=${num}` },
            { replace: true }
        )
        if(images?.length<indexDisplay){
            selectedOption !== allPhotos && handleFilterCheckboxChange(selectedOption)
        }
        const element_scroll = document.getElementById(`gallery${indexDisplay}`);
        if(window.visualViewport.scale!==1)return;
        element_scroll?.scrollIntoView();
    };

    const switchHD = async () => {
        if(get_is_downloadable(galleryImages[photoIndex-1].photo_id, collection) || get_is_downloadable(galleryImages[photoIndex-1].photo_id, faceSearchData)){
            setLoadingHD(true);
            setHdUrl((prev)=>!prev)
        }else {
            setShowToast(true)
            setToastMessage({'title':'HD not available'}) 
        }
    }

    const downloadImage = (image='') => {
        const checkIOS = getMobileOperatingSystem()
        if(image || (get_is_downloadable(galleryImages[photoIndex-1].photo_id, collection) || get_is_downloadable(galleryImages[photoIndex-1].photo_id, faceSearchData))){
            var link = document.createElement("a");
            var downloadUrl = galleryImages[photoIndex - 1].download_url;
            if(checkIOS !== "iOS"){
                link.href = image ? image.download_url : downloadUrl
                link.download = image ? `${image.image_name}` : `${galleryImages[photoIndex - 1].image_name}`;
                window.__LAST_DOWNLOAD_NAME__ = link.download;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }else{
                setLoadingHD(true);
                exportImage(downloadUrl,setLoadingHD);
                //window.open(`${process.env.REACT_APP_STAG_URL}/ios_download/?url=` + encodeURIComponent(downloadUrl), '_blank');
            }
        }else{
            setShowToast(true)
            setToastMessage({'title':'No download permission'}) 
        }
    };

    const handleApprovePhoto = (photo_id) => {
        const selectedData = collectionFormattedData;
        const selectedWorkId = get_selected_workId(selectedData, photo_id)
        setSelectionType(approvePhoto)
        setMultipleSelect((prevMultipleSelect) => {
            const index = prevMultipleSelect.findIndex((obj) => obj.work_id === selectedWorkId);
            if (index === -1) {
                prevMultipleSelect = [
                    ...prevMultipleSelect,
                    { work_id: selectedWorkId, select_list: [], unselect_list: [] },
                ];
            }

            return prevMultipleSelect.map((item) => {
                if (item.work_id === selectedWorkId) {
                    return {
                        ...item,
                        unselect_list: item.unselect_list.filter((e) => e !== photo_id),
                        select_list: [...item.select_list, photo_id],
                    };
                }
                return item;
            });
        });

        setSelectionType(approvePhoto)
        setUpdateSinglePhoto(true);
    }

    const get_photo_like_view_data = (photo_id) => {
        const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData;
        const selectedWorkId = get_selected_workId(selectedData, photo_id)
        const user_list = likeData?.[selectedWorkId]?.[photo_id]?.user_list
        return {
            user_list,
            firstFewUsers : user_list?.length >= 2 ? user_list?.slice(0, 2) : user_list,
            counts : {
                total_likes : likeData?.[selectedWorkId]?.[photo_id]?.total_likes,
                total_views : likeData?.[selectedWorkId]?.[photo_id]?.total_views
            }
        }
    }

    const get_like_view_string = (photo_id) => {
        const likes = get_photo_like_view_data(photo_id).counts.total_likes
        const views = get_photo_like_view_data(photo_id).counts.total_views
        if(likes && views){
            return `Likes & Views`
        }else if(likes){    
            return `Likes`
        }else if(views){
            return `Views`
        }
    }

    const cancelHide = () => {
        firstCheck.current = false
        document.getElementById('hidePopupDiv').style.display='none'
    }

    const handleHideImage = async (photo_id) => {
        firstCheck.current = false
        document.getElementById('hidePopupDiv').style.display='none'
        handlePhotoHide(photo_id)
    }

    const handleViewPhotos = (photo_id) => {
        if(isAdmin()){
            return;
        }
        const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/photo/views/`
        const authToken = getAuthToken();
        const headers = {
            Authorization: authToken,
            "Content-Type": "application/json",
        };
        const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData;
        const selectedWorkId = get_selected_workId(selectedData, photo_id)
        let data = { photo_id_data: [{work_id: selectedWorkId, select_list: [photo_id], unselect_list: []}] };
        if(shared_key){
            data['shared_key'] = shared_key
        }
        axios({
            method: "PUT",
            url: `${apiUrl}`,
            data: data,
            headers
        })
        .catch((error) => {
            console.error('Error removing image:', error);
        });
    }

    const recordViews = (photo_id) => {
        if (viewTimeoutRef.current) {
            clearTimeout(viewTimeoutRef.current);
        }

        viewTimeoutRef.current = setTimeout(() => {
            handleViewPhotos(photo_id);
        }, 2000);
    }

    useEffect(() => {
        if (!isSingleAddToOpen) return;
        setShowPrintAlbumTip(true);
        const t = setTimeout(() => setShowPrintAlbumTip(false), 10000);
        return () => clearTimeout(t);
    }, [isSingleAddToOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (!showGallery) return;

            if (event.key === 'Escape') {
                showGallery && closeGalleryHandler()
            }
            if(initialCarousel){
                if (event.key === "ArrowRight") {
                    carouselRef.current.goRight()
                } else if (event.key === "ArrowLeft") {
                    carouselRef.current.goLeft()
                }
            }
        };
    
        window.addEventListener('keydown', handleKeyDown);
    
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
    }, [showGallery, initialCarousel, photoIndex, reloadDelete]);

    useEffect(()=>{
        if(showGallery && photoIndex && galleryImages?.length > 0){
            recordViews(galleryImages[photoIndex-1]?.photo_id)
        }
    },[showGallery])

    useEffect(() => {
        const targetEle = document.getElementsByClassName('_ZTBlf')[0];
        const actionEle = document.getElementsByClassName('topControls')[0]
        if (targetEle) {
            const handleClick = () => {
                if(targetEle?.getAttribute('aria-label').split(' ')[0]=='Start'){
                    actionEle.style.display = 'none'
                }
                if(targetEle?.getAttribute('aria-label').split(' ')[0]=='Pause'){
                    actionEle.style.display = 'flex'
                }
            };
    
            targetEle.addEventListener('click', handleClick);
    
            return () => {
                targetEle.removeEventListener('click', handleClick);
            };
        }
    }, [showGallery]);

    return (
        <>
            {showGallery && galleryImages && photoIndex >= 0 && (
                <div  ref={thumbRef}
                onClick={handlePlayClick}
                style={{
                    position: "fixed",
                    zIndex: "200",
                    top: "0",
                    left: "0",
                    height: height,
                    width: "100vw",
                    WebkitTouchCallout: "none",
                    WebkitUserSelect: "none",
                    WebkitUserDrag: "none",
                    userSelect: "none"
                }}
                className="galleryContainer workDetailGalleryContainer"
                onContextMenu={(e) => {
                               e.preventDefault()}}
                >
                    <Carousel
                        ref={carouselRef}
                        index={photoIndex - 1}
                        images={galleryImages}
                        hasCaptions={false}
                        isLoop={false}
                        onIndexChange={handleIndexChange}
                        hasThumbnails={false}
                        canAutoPlay={true}
                        hasLeftButton={false}
                        shouldLazyLoad={true}
                        hasRightButton={false}
                        onSwipeMoveX={(e)=> window.visualViewport.scale>1.10 && e.preventDefault()}
                        onSwipeMoveY={(e)=> window.visualViewport.scale>1.10 && e.preventDefault()}
                        onTap={()=>{setLikeViewPopup(false)}}
                        elements={
                            window.visualViewport.scale<1.1 && <>
                            <button
                                style={{
                                    left: 0,
                                    top: 0.44*height,
                                    display: !prevCollectionName && photoIndex==1 && 'none'
                                }}
                                className="carouselButtons"
                                aria-label='Go to the slide on the left'
                                onClick={() => {carouselRef.current.goLeft()}}
                            >
                                <span style={{
                                    fontSize: 'min(30px, 5vw)', padding:"4vw 4vw 4vw 2vw"
                                }}>
                                    <FontAwesomeIcon icon={faAngleLeft} style={{color: "#ffffff", opacity:"0.5"}} />
                                </span>
                            </button>
                            <button
                                style={{
                                right: 0,
                                top: 0.44*height,
                                display: !nextCollectionName && photoIndex==galleryImages.length && allPhotosFullyLoaded && 'none'
                                }}
                                className="carouselButtons"
                                aria-label='Go to the slide on the right'
                                onClick={() => {carouselRef.current.goRight()}}
                            >
                                <span
                                style={{
                                    fontSize: 'min(30px, 5vw)', padding:"4vw 2vw 4vw 4vw"
                                }}
                                >
                                    <FontAwesomeIcon icon={faAngleRight} style={{color: "#ffffff", opacity:"0.5"}} />
                                </span>
                            </button>
                            </>
                        }
                    />
                    {
                        loadingHD && <div className='overlayLoader'>{globalLoader()}</div>
                    }
                    {<Popup
                    isOpen={isSingleAddToOpen}
                    onClose={() => {setIsSingleAddToOpen(false); setAddToSelection(false)}}
                    >
                        <div
                        ref={popupRef}
                        style={{
                            minWidth: currentDimensions > 600 ? "40vw" : "80vw",
                            margin: currentDimensions > 600 && "20px",
                            textAlign: "center",
                            color: "black",
                            maxHeight: "500px",
                            overflowY: "auto",
                        }}
                        className="addToMainDiv"
                        >
                        <h3 style={{ margin: "0 0 10px" }}>Add to</h3>
                        {collectionData?.[collection_id]?.album_data && get_is_album_required(galleryImages[photoIndex-1]?.photo_id, faceSearchOn ? faceSearchData : collection) && <><div style={{textAlign:"left"}}><div className="tooltip" style={{display:"inline-flex", alignItems:"center"}}><h4 style={{ fontWeight:"bold"}}>Print Albums</h4><span className={`printAlbumTip ${showPrintAlbumTip ? 'show' : ''}`}>Add Photos here to get them printed</span></div></div>
                        <ul style={{ listStyle: "none", padding: 0, marginRight:"10px" }}>
                            {collectionData && collectionData[collection_id]?.album_data?.album_data && Object.entries(collectionData[collection_id].album_data['album_data']).map(([albumKey, myAlbumData]) => (
                                <li
                                    key={albumKey}
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "10px 2px",
                                        borderBottom: "1px solid #ddd",
                                        cursor: "pointer",
                                    }}
                                >
                                <a href={`${myAlbumData.album_url}`} target="_blank" size='xs' style={{marginRight: '10px'}}><img src={myAlbumData?.cover_image} style={{minWidth:"50px", height:"35px", border:`1px solid ${get_platform_bg_color()}`, borderRadius:"5px", objectFit:"cover", objectPosition:"top"}} /></a>
                                <label
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                        cursor: "pointer",
                                        marginLeft: "5px",
                                    }}
                                >
                                    <span style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start',
                                                gap: '0.1rem',
                                                lineHeight:"1.3",
                                                }}>{myAlbumData.title} <span style={{fontSize: "0.8rem", fontWeight:"normal", whiteSpace: "nowrap"}}>(
                                                
                                                {myAlbumData.album_photo_count} photos added)</span></span>

                                    {albumData && !albumData[albumKey]?.is_locked ? <input
                                        type="checkbox"
                                        style={{
                                            cursor: "pointer",
                                            accentColor: get_platform_bg_color()
                                        }}
                                        checked={checkAlbumKey(galleryImages?.[photoIndex - 1]?.photo_id, albumKey) || false}
                                        onChange={(event) => {
                                            const isChecked = event.target.checked;
                                            updateAlbum(albumKey, isChecked, galleryImages[photoIndex - 1]?.photo_id)
                                        }}
                                        disabled={albumData && albumData[albumKey]?.is_locked || isAdmin() || !canEditDraftAlbum}
                                    /> : <span style={{ fontStyle: 'italic', color: 'gray', fontSize: 'medium' }}>Locked</span>}
                                </label>
                                </li>
                            ))}
                        </ul></>}
                        {get_can_add_to(galleryImages[photoIndex-1]?.photo_id, faceSearchOn ? faceSearchData : collection) && <><div style={{display:"flex", justifyContent:"space-between", alignItems:"center", paddingTop:"10px", marginRight:"10px"}}>
                            <h4 style={{ fontWeight:"bold"}}>My Collections</h4>
                            <h4 style={{color:"#3EA6FF", cursor:"pointer", fontWeight:"900"}} onClick={()=>{setNewFolderPopup(true)}}><FontAwesomeIcon icon={faPlus} style={{color: "#3EA6FF"}}/> New</h4>
                        </div>
                        <ul style={{ listStyle: "none", padding: 0, marginRight:"10px" }}>
                            {(libraryData?.data?.hasOwnProperty('folders') && libraryData?.data?.folders?.length > 0) ? libraryData?.data?.folders?.map((folder, index)=>(
                                <li
                                key={index}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "10px 2px",
                                    borderBottom: "1px solid #ddd",
                                    cursor: "pointer",
                                }}
                            >
                            <a href={`${folder?.folder_url}`} target="_blank" size='xs' style={{marginRight: '10px'}}><img src={folder?.cover_image} style={{minWidth:"50px", height:"35px", border:`1px solid ${get_platform_bg_color()}`, borderRadius:"5px", objectFit:"cover", objectPosition:"top"}} /></a>
                            <label
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                    cursor: "pointer",
                                    marginLeft: "5px",
                                }}
                            >
                                <span style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start',
                                                gap: '0.1rem',
                                                lineHeight:"1.3",
                                                }}>{folder?.title} <span style={{fontSize: "0.8rem", fontWeight:"normal", whiteSpace: "nowrap"}}>(
                                                
                                                {folder?.total_count} photos added)</span></span>

                                <input
                                    type="checkbox"
                                    style={{
                                        cursor: "pointer",
                                        accentColor: get_platform_bg_color()
                                    }}
                                    checked={checkFolderKey(galleryImages?.[photoIndex - 1]?.photo_id, folder.work_id) || false}
                                    onChange={(event) => {
                                        const isChecked = event.target.checked;
                                        updateFolders(folder.work_id, isChecked, galleryImages[photoIndex - 1]?.photo_id)
                                    }}
                                    disabled={isAdmin()}
                                />
                            </label>
                            </li>
                            )) : <div>No Collections!</div>}
                        </ul></>}
                        </div>
                        <button
                            style={{
                                marginRight: "2vw",
                                padding: "5px 8px",
                                backgroundColor: get_platform_action_color(),
                                border: "none",
                                borderRadius: "5px",
                                color: "white",
                                cursor: "pointer",
                            }}
                            onClick={() => {setIsSingleAddToOpen(false); setAddToSelection(false);setPrintSelection(false)}}
                        >
                            Done
                        </button>
            </Popup>}
                    {window.visualViewport.scale < 1.05 && <div style={{top: currentDimensions < 600 && (0.85*window.innerHeight), bottom: currentDimensions > 600 && '2.5%'}} className="likedStories" onClick={()=>{setLikeViewPopup(!likeViewPopup)}}>
                        {get_photo_like_view_data(galleryImages[photoIndex-1]?.photo_id).firstFewUsers?.length>0 &&
                        <div style={{position: 'relative', display:"flex", alignItems:"center"}}>
                            {get_photo_like_view_data(galleryImages[photoIndex-1]?.photo_id).firstFewUsers.map((e, index)=>(
                                <div key={index} style={{display:"flex", alignItems:"center"}}>
                                    <div className="profileDiv" style={{border: `1px solid ${get_platform_bg_color()}`,
                                                                        backgroundColor: get_platform_bg_color(), 
                                                                        fontWeight:"900",
                                                                        position:"absolute",
                                                                        left: index === 1 ? (currentDimensions>=600 ? '35px' : "24px") : "0%",
                                                                        zIndex: index === 1 ? 1 : 0,
                                                                        boxShadow: index === 1 ? "-1px 0px 0px rgba(0, 0, 0, 0.7)" : "none", 
                                                                        transition: "all 0.3s ease-in-out"}}>{e.name_initials}</div>
                                </div>))
                            }
                            <div style={{cursor:"pointer"}}>
                                <div style={{position:'relative',
                                                left: get_photo_like_view_data(galleryImages[photoIndex-1]?.photo_id).firstFewUsers.length>1 ? (currentDimensions>=600 ? '90px' : "60px") : (currentDimensions>=600 ? '50px' : "35px"),
                                                fontSize:"14px",
                                }}>
                                    <span style={{marginRight:"5px"}}>{get_photo_like_view_data(galleryImages[photoIndex-1]?.photo_id).counts.total_likes>0 ? 'Liked by' : 'Viewed by'}</span>
                                    <span><span style={{fontWeight:'600'}}>{get_photo_like_view_data(galleryImages[photoIndex-1]?.photo_id).firstFewUsers[0]?.first_name}</span> {get_photo_like_view_data(galleryImages[photoIndex-1]?.photo_id)?.user_list.length>1 && (<> and <span style={{ fontWeight: '600' }}>others</span></>)}</span>
                                </div>
                            </div>
                            
                        </div>}
                    </div>}
                    
                    {tab == guestUpload && get_can_flag_pics(collection) && !isOwnUpload && (!currentPhotoFlagged ? 
                        <button className="flagButton2" onClick={() => setFlagPhotoPopup(true)} style={{bottom: currentDimensions > 600 && '2.2%'}} >
                                <div className="flagBtn" 
                                >
                                    <img src="https://assets.eventgraphia.com/site_media/react/flag.png" alt="not-flagged" className="invert-image"/></div>
                                    <p style={{ fontWeight: "600", fontSize:'0.9rem' }}>{"Report"}</p>
                        </button>

                        :

                        <p style={{ fontWeight: "600", fontSize:'0.9rem', color: '#CF0F47', bottom: currentDimensions > 600 && '2.2%' }} className="flaggedText2" >Reported</p>)
                    }


                    {likeViewPopup && <div style={{padding:"15px 0"}} className={currentDimensions < 600 ? "drawer open" : "likeViewPopup"}>
                        <div style={{width:"inherit"}}>
                            <div style={{fontWeight:"600", display:"flex", justifyContent:"space-between", alignItems:"center", padding: "0 15px 15px 15px"}}>
                                <div style={{width:"12px"}}></div>
                                <div>
                                    <div>{get_like_view_string(galleryImages[photoIndex-1]?.photo_id)}</div>
                                </div>
                                <div className="likedPopupClose" onClick={()=>{setLikeViewPopup(false)}} style={{cursor:"pointer"}}><FontAwesomeIcon icon={faXmark} size="lg"/></div>
                            </div>
                            <hr style={{width:"inherit"}}/>
                            <div className="likeViewContent" style={{padding: "10px 15px", maxHeight: currentDimensions < 600 ? "52vh" : "400px", overflowY:"auto"}}>
                                {get_photo_like_view_data(galleryImages[photoIndex-1]?.photo_id)?.user_list?.map((e, index)=>(
                                    <div key={index} style={{padding:"10px", display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                                        <div style={{display:"flex", alignItems:"center"}}>
                                            <div className="profileDiv" style={{border: `1px solid ${get_platform_bg_color()}`,backgroundColor: get_platform_bg_color(), fontWeight:"900", minWidth:"30px", minHeight:"30px"}}>{e.name_initials}</div>
                                            <div style={{padding: "0 10px", letterSpacing:"0.03rem"}}>{e.first_name}</div>
                                        </div>
                                        {e.is_liked && <div style={{display:"flex", alignItems:"center"}}><img style={{width:"20px", marginRight:"5px"}} src={redHeartIcon} alt="like"/></div>}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>}
                    {window.visualViewport.scale<1.4 && <div onClick={()=>setLikeViewPopup(false)} style={{top:currentDimensions < 600 && (0.90*height)}} className={currentDimensions > 600 ? 'topControls' : `${faceSearchOn ? ((get_can_add_to(galleryImages[photoIndex-1]?.photo_id, faceSearchData) || get_is_album_required(galleryImages[photoIndex-1]?.photo_id, faceSearchData) && tab!==guestUpload) ? 'bottomControls' : 'centerControls') : ((get_can_add_to(galleryImages[photoIndex - 1]?.photo_id, collection) || get_is_album_required(galleryImages[photoIndex-1]?.photo_id, collection) && tab!==guestUpload) ? 'bottomControls' : 'centerControls')}`}>
                        {(faceSearchOn ? (get_can_add_to(galleryImages[photoIndex-1]?.photo_id, faceSearchData) || get_is_album_required(galleryImages[photoIndex-1]?.photo_id, faceSearchData)) : (get_can_add_to(galleryImages[photoIndex - 1]?.photo_id, collection) || get_is_album_required(galleryImages[photoIndex-1]?.photo_id, collection))) && <><div className={`${faceSearchOn ? ((get_global_can_add_to(faceSearchData) || get_global_is_album_required(faceSearchData)) && currentDimensions < 600 ? 'leftCenterControls' : 'topCenterControls') : ((get_can_add_to(galleryImages[photoIndex - 1]?.photo_id, collection) || get_is_album_required(galleryImages[photoIndex-1]?.photo_id, collection)) && currentDimensions < 600 ? 'leftCenterControls' : 'topCenterControls')}`}>
                            <div style={{display: (tab==guestUpload || (faceSearchOn && !has_hd_quality(faceSearchData))) && 'none'}} className={
                                    faceSearchOn
                                        ? (get_is_downloadable(galleryImages[photoIndex-1].photo_id, faceSearchData) ? (hdUrl ? 'activeHD' : 'hdButton') : 'displayNone')
                                        : (get_is_downloadable(galleryImages[photoIndex-1].photo_id, collection) ? (hdUrl ? 'activeHD' : 'hdButton') : 'displayNone')
                                } onClick={switchHD}>
                                <p>HD</p>
                            </div>
                            {!selection && (faceSearchOn ? get_can_delete(galleryImages[photoIndex - 1]?.photo_id, faceSearchData) : get_can_delete(galleryImages[photoIndex - 1]?.photo_id, collection) || (collection?.album_delete && !albumLocked && canEditDraftAlbum) || (tab==userFolders && collection?.admin_delete && !showTrash)) && <div className="deleteDiv" style={{cursor:"pointer", marginLeft: currentDimensions>600 && (currentDimensions>900 ? '20px' : "15px")}} onClick={()=>handleDeletePhoto(galleryImages[photoIndex-1]?.photo_id)}><img style={{width: "22px"}} className="coloredImage" src={deleteIcon} alt='delete'/></div>} 
                            {<div className={
                                faceSearchOn 
                                    ? (get_can_make_private(galleryImages[photoIndex-1].photo_id, faceSearchData) ? 'galleryHide' : 'displayNone')
                                    : (get_can_make_private(galleryImages[photoIndex-1].photo_id, collection) ? 'galleryHide' : 'displayNone')
                            } onClick={()=>handlePhotoHide(galleryImages[photoIndex-1]?.photo_id)}>
                                {faceSearchOn ? (
                                    faceHide && Object.keys(faceHide).length>0 && Object.keys(faceHide)?.some((key) =>
                                        faceHide[key]?.some(e => e.photo_id === galleryImages[photoIndex - 1]?.photo_id)
                                    ) ? (
                                        <img style={{ width: "24px" }} src={redHideIcon} />
                                    ) : (
                                        <img style={{ width: "24px" }} src={whiteHideIcon} />
                                    )
                                    ) : (
                                    tab!==userFolders && hideSelectedObj && Object.keys(hideSelectedObj).length>0 && Object.keys(hideSelectedObj)?.some((key) =>
                                        hideSelectedObj[key]?.some(e => e.photo_id === galleryImages[photoIndex - 1]?.photo_id)
                                    ) ? (
                                        <img style={{ width: "24px" }} src={redHideIcon} />
                                    ) : (
                                        <img style={{ width: "24px" }} src={whiteHideIcon} />
                                    )
                                )}
                            </div>}
                        </div>
                        {(!faceSearchOn ? (get_can_add_to(galleryImages[photoIndex - 1]?.photo_id, collection) || get_is_album_required(galleryImages[photoIndex-1]?.photo_id, collection)) : (get_can_add_to(galleryImages[photoIndex - 1]?.photo_id, faceSearchData) || get_is_album_required(galleryImages[photoIndex - 1]?.photo_id, faceSearchData))) && <div className='galleryAddto' onClick={toggleSingleAddToPopup}>
                            <FontAwesomeIcon icon={faPlus} style={{color: "#000000"}}/> Add to
                        </div>}                                
                        <div className={`${faceSearchOn ? ((get_can_add_to(galleryImages[photoIndex-1].photo_id, faceSearchData) || get_is_album_required(galleryImages[photoIndex-1]?.photo_id, faceSearchData)) && currentDimensions < 600 ? 'rightCenterControls' : 'topCenterControls') : ((get_can_add_to(galleryImages[photoIndex - 1]?.photo_id, collection) || get_is_album_required(galleryImages[photoIndex-1]?.photo_id, collection)) && currentDimensions < 600 ? 'rightCenterControls' : 'topCenterControls')}`}>
                            <div
                                className={
                                    faceSearchOn
                                        ? (get_is_downloadable(galleryImages[photoIndex-1].photo_id, faceSearchData) ? 'downloadButton' : 'displayNone')
                                        : (get_is_downloadable(galleryImages[photoIndex-1].photo_id, collection) ? 'downloadButton' : 'displayNone')
                                }
                                onClick={()=>downloadImage(this)}
                            >
                                <img style={{height: "20px"}} src={downloadIcon} className="coloredImage" alt="download"/>
                            </div>
                            <div className="likeDiv" onClick={()=>handleLikeViewPhoto(galleryImages[photoIndex-1]?.photo_id, likePhotos)}>
                                <img className={currentPhotoLiked ? "" : "invert-image"} style={{width: "22px"}} src={currentPhotoLiked ? redHeartIcon : heartIcon}/>
                            </div>
                  
                        </div></>}
                        {(faceSearchOn ? (!get_can_add_to(galleryImages[photoIndex-1]?.photo_id, faceSearchData) && !get_is_album_required(galleryImages[photoIndex-1]?.photo_id, faceSearchData)) : (!get_can_add_to(galleryImages[photoIndex - 1]?.photo_id, collection) && !get_is_album_required(galleryImages[photoIndex-1]?.photo_id, collection))) && <>
                            {!selection && (faceSearchOn ? get_can_delete(galleryImages[photoIndex - 1]?.photo_id, faceSearchData) : get_can_delete(galleryImages[photoIndex - 1]?.photo_id, collection) || collection?.album_delete || (tab==userFolders && collection?.admin_delete && !showTrash)) && <div className="deleteDiv" style={{cursor:"pointer"}} onClick={()=>handleDeletePhoto(galleryImages[photoIndex-1]?.photo_id)}><img style={{width:"22px"}} className="coloredImage" src={deleteIcon} alt='delete'/></div>}
                            <div style={{display: (tab==guestUpload || (faceSearchOn && !has_hd_quality(faceSearchData))) && 'none'}} className={
                                    faceSearchOn
                                        ? (get_is_downloadable(galleryImages[photoIndex-1]?.photo_id, faceSearchData) ? (hdUrl ? 'activeHD' : 'hdButton') : 'displayNone')
                                        : (get_is_downloadable(galleryImages[photoIndex-1]?.photo_id, collection) ? (hdUrl ? 'activeHD' : 'hdButton') : 'displayNone')
                                } onClick={switchHD}>
                                <p>HD</p>
                            </div>

                            {!selection && !faceSearchOn && tab==blacklistReview && <div className="approveDiv galleryApproveDiv" style={{cursor:"pointer", marginLeft: currentDimensions>600 && (currentDimensions>900 ? '20px' : "15px"), display : faceSearchOn && 'none', background: 'white', color:"black", padding: '5px 8px', borderRadius: '5px'}} onClick={()=>handleApprovePhoto(galleryImages[photoIndex-1]?.photo_id)}><img  src={"https://assets.eventgraphia.com/site_media/react/approval.png"} className="invert-image" alt='approve'/> {" "}Approve</div>} 

                            {<div className={
                                faceSearchOn 
                                    ? (get_can_make_private(galleryImages[photoIndex-1]?.photo_id, faceSearchData) ? 'galleryHide' : 'displayNone')
                                    : (get_can_make_private(galleryImages[photoIndex-1]?.photo_id, collection) ? 'galleryHide' : 'displayNone')
                            } onClick={()=>handlePhotoHide(galleryImages[photoIndex-1]?.photo_id)}>
                                {faceSearchOn ? (
                                    faceHide && Object.keys(faceHide).length>0 && Object.keys(faceHide)?.some((key) =>
                                        faceHide[key]?.some(e => e.photo_id === galleryImages[photoIndex - 1]?.photo_id)
                                    ) ? (
                                        <img style={{ width: "24px" }} src={redHideIcon} />
                                    ) : (
                                        <img style={{ width: "24px" }} src={whiteHideIcon} />
                                    )
                                    ) : (
                                    tab!==userFolders && hideSelectedObj && Object.keys(hideSelectedObj).length>0 && Object.keys(hideSelectedObj)?.some((key) =>
                                        hideSelectedObj[key]?.some(e => e.photo_id === galleryImages[photoIndex - 1]?.photo_id)
                                    ) ? (
                                        <img style={{ width: "24px" }} src={redHideIcon} />
                                    ) : (
                                        <img style={{ width: "24px" }} src={whiteHideIcon} />
                                    )
                                )}
                            </div>}
                            {faceSearchOn && (get_can_add_to(galleryImages[photoIndex - 1]?.photo_id, faceSearchData) || get_is_album_required(galleryImages[photoIndex - 1]?.photo_id, faceSearchData)) && <div className='galleryAddto' onClick={toggleSingleAddToPopup}>
                                <FontAwesomeIcon icon={faPlus} style={{color: "#000000"}}/> Add to
                            </div>}


                            <div
                                className={
                                    faceSearchOn
                                        ? (get_is_downloadable(galleryImages[photoIndex-1]?.photo_id, faceSearchData) ? 'downloadButton' : 'displayNone')
                                        : (get_is_downloadable(galleryImages[photoIndex-1]?.photo_id, collection) ? 'downloadButton' : 'displayNone')
                                }
                                onClick={()=>downloadImage(this)}
                            >
                                <img style={{height: "20px"}} src={downloadIcon} className="coloredImage" alt="download"/>
                            </div>
                            <div className="likeDiv" onClick={()=>handleLikeViewPhoto(galleryImages[photoIndex-1]?.photo_id, likePhotos)}>
                                <img className={get_user_liked_photos(likeData, galleryImages[photoIndex-1]?.photo_id) ? "" : "invert-image"} style={{width: "22px"}} src={get_user_liked_photos(likeData, galleryImages[photoIndex-1]?.photo_id) ? redHeartIcon : heartIcon}/>
                            </div>
                        </>}
                    </div>}
                    <div
                    style={{ position: "absolute", top: "0", left: "0", width: '60px', height:"50px", display:"flex", justifyContent:"center", alignItems:"center" }}
                    onClick={closeGalleryHandler}
                        >
                            <FontAwesomeIcon
                            icon={faArrowLeft}
                            size="xl"
                            className="closeEffect"
                            />
                    </div>
                    <div className="galleryCustomCounter">
                        {`${photoIndex || 1} / ${totalPhotoCount}`}
                    </div>

                    <div className="photoName" style={{display: 'flex', justifyContent: "space-between", gap: '1.4rem'}}>
                        <p>{galleryImages[photoIndex-1]?.alt.length>15 ? galleryImages[photoIndex-1]?.alt.slice(0, 15)+'...' : galleryImages[photoIndex-1]?.alt}</p>
                        {currentDimensions <= 600 && (browser !== firefox) && (faceSearchOn? 
                        get_is_downloadable(galleryImages[photoIndex - 1]?.photo_id, faceSearchData) : 
                        get_is_downloadable(galleryImages[photoIndex - 1]?.photo_id, collection))
                        &&(<div className='shareWrapper' onClick={(e) =>{
                             setLoadingHD(true);
                             e.stopPropagation();
                             e.preventDefault();
                        exportImage(galleryImages[photoIndex - 1]?.download_url,setLoadingHD)
                        }}>
                        <img src={shareIcon} style={{marginTop:"3px", width: "16px", filter: "invert(1)" }}alt="Share"/>
                        </div>)}        
                    </div>
                      
                    {tab == guestUpload && get_can_flag_pics(collection) && !isOwnUpload &&( !currentPhotoFlagged ?
                        <button className="flagButton" onClick={() => setFlagPhotoPopup(true)}>
                                <div className="flagBtn" 
                                ><img src="https://assets.eventgraphia.com/site_media/react/flag.png" alt="not-flagged" className={currentDimensions > 600 && "invert-image"} /></div>
                                <p style={{ fontWeight: "600", fontSize:'0.7rem' }}>{"Report"}</p>
                        </button>

                        :

                        <p style={{ fontWeight: "600", fontSize:'0.9rem', color: '#CF0F47' }} className="flaggedText" >Reported</p>)
                    }
                </div>
            )}
            <div id="hidePopupDiv">
                <div id="hidePhotoPopup">
                    <h1><span id="popupTitle">Hide</span> this Photo?</h1>
                    <h2 id="popupDesc">Hidden photos won't be visible to everyone(except Admin)</h2>
                    <h3>Note</h3>
                    <li>Only Admin can hide/unhide photos</li>
                    <div id="hideButtonDiv">
                        <button id="hideButtonGallery" onClick={()=>handleHideImage(galleryImages[photoIndex-1]?.photo_id)} style={{backgroundColor: get_platform_bg_color()}}>Hide</button>
                        <button id="cancelHideButton" onClick={cancelHide}>Cancel</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GalleryCarousel